{
  "intro": "เพิ่มหรือแก้สินค้าจำนวนมากพร้อมกันด้วยไฟล์ตาราง (CSV) ระบบตรวจไฟล์ก่อน — ยังไม่บันทึกอะไรจนกว่าจะกด “นำเข้า”",
  "tabs": {
    "import": "นำเข้าไฟล์",
    "export": "ดาวน์โหลดสินค้า",
    "history": "การนำเข้าที่ผ่านมา"
  },
  "steps": {
    "upload": "1. เลือกไฟล์",
    "mapping": "2. คอลัมน์ไหนคืออะไร",
    "check": "3. ตรวจ",
    "import": "4. นำเข้า"
  },
  "upload": {
    "title": "เลือกไฟล์ CSV",
    "drop": "วางไฟล์ที่นี่ หรือ",
    "choose": "เลือกไฟล์",
    "hint": "Excel: “บันทึกเป็น → CSV UTF-8” ไม่เกิน 20 MB",
    "too_large": "ไฟล์นี้ {{size}} MB — สูงสุด 20 MB แบ่งเป็นไฟล์เล็กๆ (เช่น แยกตามเกม) แล้วนำเข้าทีละไฟล์",
    "not_csv": "ไม่ใช่ไฟล์ CSV ใน Excel ให้เลือก “บันทึกเป็น → CSV UTF-8 (คั่นด้วยจุลภาค)”",
    "empty": "ไฟล์นี้ไม่มีแถวข้อมูล",
    "reading": "กำลังอ่านไฟล์…",
    "templates": "ไฟล์เปล่าสำหรับกรอก",
    "templates_hint": "ดาวน์โหลดไฟล์รูปแบบที่ถูกต้อง ลบแถวตัวอย่างแล้วกรอกของคุณ",
    "template_native": "แบบเต็ม (ทุกช่อง)",
    "template_shopify": "แบบ Shopify",
    "template_quick_cards": "รายการการ์ดย่อ (เกม ชุด เลข แรงก์ ราคา)"
  },
  "profiles": {
    "native": "แบบเต็มของร้าน",
    "shopify": "ไฟล์ส่งออกจาก Shopify",
    "quick_cards": "รายการการ์ดย่อ"
  },
  "mapping": {
    "detected": "ไฟล์นี้ดูเหมือน: {{profile}}",
    "not_detected": "ไม่รู้จักรูปแบบไฟล์ — เลือกรูปแบบแล้วบอกว่าคอลัมน์ไหนคืออะไร",
    "layout": "รูปแบบไฟล์",
    "column": "คอลัมน์ในไฟล์",
    "sample": "ตัวอย่างค่า",
    "field": "หมายถึง",
    "skip": "— ไม่นำเข้า —",
    "sure": "แน่ใจ",
    "unsure": "โปรดตรวจ",
    "remembered": "จำจากครั้งก่อน",
    "missing_required": "ไฟล์ต้องมีคอลัมน์เหล่านี้: {{fields}}",
    "missing_raw": "ถ้าไฟล์มีการ์ดดิบ ให้เลือกคอลัมน์แรงก์ (A–D): {{fields}}",
    "missing_graded": "ถ้าไฟล์มีการ์ดเกรด ให้เลือกคอลัมน์เหล่านี้: {{fields}}",
    "duplicate": "มีสองคอลัมน์ชี้ไปที่ช่องเดียวกัน: {{fields}} เลือก “ไม่นำเข้า” ให้คอลัมน์หนึ่ง",
    "check": "ตรวจไฟล์",
    "back": "เลือกไฟล์อื่น",
    "rows_in_file": "{{count}} แถวในไฟล์",
    "field_of": "คอลัมน์ {{column}} หมายถึง"
  },
  "check": {
    "running": "กำลังตรวจแถว {{done}} จาก {{total}}…",
    "queued": "รอเริ่ม…",
    "title": "ผลการตรวจ",
    "creates": "สินค้าใหม่",
    "updates": "สินค้าที่จะเปลี่ยน",
    "errors": "แถวที่มีปัญหา",
    "warnings": "แถวที่ควรดู",
    "skips": "ไม่เปลี่ยน / ข้าม",
    "no_errors": "ไม่พบปัญหา นำเข้าได้เลย",
    "problem_rows": "แถวที่มีปัญหา",
    "row": "บรรทัดในไฟล์",
    "code": "สินค้า",
    "what": "ปัญหาคืออะไร",
    "download_problems": "ดาวน์โหลดเฉพาะแถวที่มีปัญหา",
    "download_report": "ดาวน์โหลดไฟล์พร้อมผลแต่ละแถว",
    "only_good": "นำเข้าเฉพาะ {{count}} แถวที่ไม่มีปัญหา (แถวอื่นถูกข้าม)",
    "fix_and_upload": "แก้ไฟล์แล้วอัปโหลดใหม่",
    "import": "นำเข้า",
    "import_locked": "เลือก “นำเข้าเฉพาะแถวที่ไม่มีปัญหา” หรืออัปโหลดไฟล์ที่แก้แล้ว",
    "failed": "ตรวจไฟล์ไม่ได้: {{error}}",
    "cancel": "หยุด",
    "cancelled": "หยุดแล้ว"
  },
  "rank_map": {
    "title": "คำบอกสภาพแบบเก่าในคอลัมน์แรงก์",
    "hint": "ร้านให้แรงก์การ์ดดิบเป็น A / B / C / D เลือกแรงก์สำหรับแต่ละคำด้านล่าง — เปลี่ยนเฉพาะไฟล์นี้ แล้วตรวจใหม่",
    "found": "ในไฟล์",
    "rows": "จำนวนแถว",
    "rank": "ใช้แรงก์",
    "apply": "ใช้แรงก์นี้แล้วตรวจใหม่",
    "no_file": "เลือกไฟล์อีกครั้งเพื่อเปลี่ยนคำแรงก์ (เบราว์เซอร์ไม่เก็บไฟล์ไว้หลังโหลดหน้าใหม่)",
    "done": "เปลี่ยนแรงก์ในไฟล์ {{count}} แห่ง",
    "rank_for": "แรงก์ที่ใช้แทน “{{value}}”"
  },
  "import": {
    "running": "กำลังนำเข้าแถว {{done}} จาก {{total}}…",
    "done_title": "นำเข้าเสร็จแล้ว",
    "done": "ใหม่ {{created}} · เปลี่ยน {{updated}} · ข้าม {{skipped}}",
    "see_products": "ดูสินค้าที่นำเข้า",
    "another": "นำเข้าไฟล์อื่น",
    "left_page": "ออกจากหน้านี้ได้ — การนำเข้ายังทำต่อ กลับมาดูที่ “การนำเข้าที่ผ่านมา”"
  },
  "history": {
    "empty": "ยังไม่เคยนำเข้า",
    "open": "เปิด",
    "rows": "{{count}} แถว",
    "errors_count": "มีปัญหา {{count}} แถว"
  },
  "status": {
    "queued": "รอ",
    "validating": "กำลังตรวจ",
    "ready": "ตรวจแล้ว",
    "applying": "กำลังนำเข้า",
    "done": "นำเข้าแล้ว",
    "failed": "ไม่สำเร็จ",
    "cancelled": "หยุดแล้ว"
  },
  "row_status": {
    "ok": "ผ่าน",
    "warning": "ผ่าน (ตรวจดู)",
    "error": "มีปัญหา",
    "skipped": "ข้าม"
  },
  "export": {
    "title": "ดาวน์โหลดสินค้า",
    "hint": "สินค้าทั้งหมดของร้านเป็นไฟล์ CSV ถ้าต้องการบางส่วน (มุมมองที่บันทึก ตัวกรอง) ให้ใช้ “ดาวน์โหลด” ในหน้ารายการสินค้า",
    "format": "รูปแบบ",
    "native": "แบบเต็มของร้าน (นำเข้ากลับได้)",
    "shopify": "แบบ Shopify",
    "download": "ดาวน์โหลด",
    "preparing": "กำลังเตรียมไฟล์…",
    "done": "ดาวน์โหลดแล้ว",
    "recent": "ที่ดาวน์โหลดในเครื่องนี้",
    "none": "ยังไม่เคยดาวน์โหลด"
  },
  "row": {
    "required": "ต้องกรอก {{field}}",
    "invalid_value": "{{field}}: ค่า “{{value}}” ไม่ถูกต้อง",
    "invalid_money": "{{field}}: ใส่ราคาเป็นเยนเต็มจำนวน (เช่น 19000)",
    "duplicate_in_file": "{{field}} “{{value}}” ซ้ำในไฟล์นี้ (พบครั้งแรกแถว {{firstRow}})",
    "game_not_found": "ไม่พบเกม “{{value}}” — เพิ่มในแคตตาล็อกการ์ดก่อน",
    "set_not_found": "ไม่พบชุด “{{value}}” ของเกมนี้",
    "set_ambiguous": "ชุด “{{value}}” มีหลายภาษา — กรอก set_language",
    "card_not_found": "ไม่พบการ์ด {{value}} ในชุดนี้ (เปิด “สร้างการ์ดที่ไม่มี” เพื่อเพิ่ม)",
    "card_ambiguous": "มีการ์ดหมายเลข {{value}} หลายใบ — กรอก card_name_en",
    "card_will_be_created": "จะเพิ่มการ์ด {{value}} ในแคตตาล็อก",
    "category_not_found": "ไม่พบหมวดหมู่ “{{value}}”",
    "invalid_reference": "{{field}}: ข้อมูลที่แถวนี้อ้างถึงไม่มีแล้ว — เลือกใหม่",
    "sku_generated": "ระบบจะสร้างรหัสสินค้าให้อัตโนมัติ",
    "taxable_forced_true": "การ์ดต้องเสียภาษีบริโภคเสมอ — ตั้ง taxable เป็น true",
    "price_near_cost": "ราคาใกล้เคียงต้นทุนมาก ({{price}} / {{cost}})",
    "seo_duplicate_ignored": "{{field}} ซ้ำกัน {{count}} แถว — ข้ามไปและสร้างให้อัตโนมัติ",
    "cert_conflict": "บาร์โค้ด ({{barcode}}) กับเลขใบรับรอง ({{certNumber}}) ไม่ตรงกัน",
    "grade_conflict": "เกรดใน {{field}} ({{found}}) ไม่ตรงกับ grade ({{grade}})",
    "legacy_condition_alias_mapped": "อ่าน “{{value}}” เป็นแรงก์ {{rank}}",
    "media_import_deferred": "เก็บลิงก์รูปไว้แล้ว จะเพิ่มรูปเมื่อเชื่อมต่อบริการสื่อ",
    "status_not_allowed": "status “{{value}}” ใช้ที่นี่ไม่ได้ (ใช้ draft หรือ active)",
    "variant_ambiguous": "สินค้านี้มีหลายตัวเลือก — กรอกคอลัมน์รหัสสินค้าเพื่อเลือก",
    "unchanged": "ไม่มีการเปลี่ยนแปลง — ข้าม",
    "title_not_parsed": "ชื่อสินค้าไม่อยู่ในรูปแบบ “การ์ด – ชุด (เลข) (JP)” — เก็บตามที่พิมพ์ไว้",
    "set_unresolved": "ไม่พบชุด “{{value}}” ในแคตตาล็อก — บันทึกสินค้าโดยไม่ผูกกับการ์ด",
    "game_unresolved": "ผู้ขาย “{{value}}” ไม่ใช่เกมในแคตตาล็อก — บันทึกโดยไม่ระบุเกม",
    "category_unresolved": "ไม่พบหมวดหมู่ “{{value}}” — บันทึกโดยไม่มีหมวดหมู่",
    "product_type_ambiguous": "ไม่ทราบว่าเป็นการ์ดเกรด การ์ดไม่เกรด หรือสินค้าซีล (“{{value}}”) — กรอกช่องสภาพ ({{allowed}})",
    "qty_ignored_use_inventory": "ไม่ได้นำเข้าจำนวน ({{value}}) — รับสต็อกที่หน้าสต็อกด้วยรหัสสินค้า",
    "card_created_without_name": "ไม่มีการ์ด {{value}} ในแคตตาล็อก จึงเพิ่มเป็น “{{name}}” — แก้ชื่อจริงในแคตตาล็อกการ์ด",
    "image_row": "รูปเพิ่มของสินค้าแถวที่ {{firstRow}}",
    "variant_rows_not_supported": "ตัวเลือกที่สองของ {{handle}} (แถว {{firstRow}}) — ลงการ์ดแต่ละใบเป็นสินค้าแยกกัน",
    "card_not_found_kept": "ไม่พบการ์ด {{value}} ในชุดนี้ — บันทึกโดยไม่ผูกกับการ์ด",
    "not_applied_because_of_errors": "ไม่ได้นำเข้า: แก้ข้อผิดพลาดของแถวนี้",
    "raw_rank_required": "การ์ดเดี่ยวต้องมีแรงก์ (A, B, C หรือ D)",
    "legacy_condition_alias_rejected": "“{{value}}” ไม่ใช่แรงก์ของร้าน — ใช้ A–D (แนะนำ: {{suggested}})",
    "invalid_raw_rank": "แรงก์ต้องเป็น A, B, C หรือ D (ได้ “{{value}}”)",
    "graded_fields_required": "การ์ดเกรดต้องมีบริษัทเกรด เกรด และเลขใบรับรอง",
    "invalid_grade": "เกรดต้องอยู่ระหว่าง 1–10 ทีละ 0.5 (PSA เป็นจำนวนเต็ม)",
    "weight_required": "สินค้าซีลต้องระบุน้ำหนัก (กรัม)",
    "duplicate_cert": "เลขใบรับรองนี้ลงขายในสินค้าอื่นแล้ว",
    "duplicate_sku": "รหัสสินค้านี้ถูกใช้แล้ว",
    "duplicate_barcode": "บาร์โค้ดนี้ถูกใช้กับสินค้าอื่นแล้ว",
    "invalid_ean": "บาร์โค้ดไม่ใช่ JAN/EAN-13 ที่ถูกต้อง",
    "reserved_handle": "ที่อยู่เว็บ (handle) นี้ถูกสงวนไว้",
    "handle_recently_used": "ที่อยู่เว็บ (handle) นี้เพิ่งถูกใช้กับสินค้าอื่น",
    "unknown_attribute": "ไม่รู้จักช่องเพิ่มเติม {{field}}",
    "invalid_attribute": "ค่าของช่องเพิ่มเติม {{field}} ไม่ถูกต้อง",
    "compare_at_type_not_allowed": "การ์ดเดี่ยวใช้ราคาป้าย (MSRP) เป็นราคาเปรียบเทียบไม่ได้",
    "price_below_cost": "ราคา ({{price}}) ต่ำกว่าต้นทุน ({{cost}})",
    "export_price_low": "ราคาส่งออกต่ำกว่าราคาก่อนภาษีมาก",
    "invalid_cert_format": "เลขใบรับรองไม่ตรงรูปแบบของ {{gradingCompany}}",
    "similar_product_exists": "มีการ์ดใบเดียวกันสภาพเดียวกันลงขายอยู่แล้ว ({{count}})",
    "publish_blocked": "บันทึกเป็นแบบร่าง: ขายได้เมื่อมีรูปพร้อม",
    "condition_type_mismatch": "ประเภทสภาพไม่ตรงกับประเภทสินค้า",
    "product_type_conflict": "{{field}}: สินค้า “{{handle}}” มีอยู่แล้วเป็น {{existing}} — ใช้ handle/รหัสอื่น หรือแก้ประเภทสินค้า",
    "forbidden__publish_not_allowed": "การเปิดขาย (สถานะ / ช่องทางขาย) ต้องมีสิทธิ์เผยแพร่ — เว้นช่องนี้ว่างหรือให้เจ้าของร้านทำ",
    "forbidden__write_not_allowed": "บัญชีนี้เพิ่มหรือแก้ไขสินค้าไม่ได้",
    "forbidden__master_data_not_allowed": "{{field}}: การเพิ่มชุด/การ์ดที่ยังไม่มีต้องมีสิทธิ์แคตตาล็อก",
    "forbidden__consignment_scope_pending": "สิทธิ์ฝากขายแก้ได้เฉพาะสินค้าฝากขาย — ยังใช้กับการนำเข้าไม่ได้",
    "conflict": "{{field}} ถูกใช้กับสินค้าอื่นแล้ว",
    "validation_failed__matches_auto_pattern": "{{field}}: รหัสรูปแบบของร้าน ({{pattern}}) ระบบสร้างให้เอง — เว้นว่างหรือใช้รหัสอื่น",
    "validation_failed__invalid_format": "{{field}}: “{{value}}” มีตัวอักษรที่ใช้ไม่ได้ ({{allowed}})",
    "validation_failed": "{{field}}: กรุณาตรวจสอบค่านี้"
  },
  "fields": {
    "external_ref": "เลขอ้างอิงของคุณ",
    "handle": "ชื่อในลิงก์เว็บ",
    "product_type": "ประเภท (ดิบ / เกรด / ซีล)",
    "game_slug": "เกม",
    "set_code": "รหัสชุด",
    "set_language": "ภาษาการ์ด",
    "set_name_en": "ชื่อชุด (อังกฤษ)",
    "card_number": "เลขการ์ด",
    "card_name_en": "ชื่อการ์ด (อังกฤษ)",
    "title_en": "ชื่อสินค้า (อังกฤษ)",
    "title_ja": "ชื่อสินค้า (ญี่ปุ่น)",
    "description_en": "คำอธิบาย (อังกฤษ)",
    "detail_text": "รายละเอียด",
    "category_slug": "หมวดหมู่",
    "tags": "แท็ก",
    "status": "สถานะ (ขาย / ร่าง)",
    "sales_channels": "ขายที่ไหน",
    "vendor": "ผู้ผลิต / แบรนด์",
    "sku": "รหัสสินค้า",
    "barcode": "บาร์โค้ด (JAN)",
    "price": "ราคา (เยน รวมภาษี)",
    "compare_at_price": "ราคาอ้างอิง",
    "compare_at_evidence_type": "ที่มาของราคาอ้างอิง",
    "compare_at_source_url": "ลิงก์ของราคาอ้างอิง",
    "compare_at_methodology": "วิธีหาราคาอ้างอิง",
    "export_price": "ราคาสำหรับต่างประเทศ",
    "cost": "ราคาทุน",
    "weight_g": "น้ำหนัก (กรัม)",
    "taxable": "มีภาษีบริโภค",
    "raw_rank": "แรงก์ (A–D)",
    "raw_rank_damaged": "เสียหาย (แรงก์ D)",
    "rank_note_en": "หมายเหตุแรงก์ (อังกฤษ)",
    "grading_company": "บริษัทเกรด",
    "grade": "เกรด",
    "grade_label": "ป้ายเกรด",
    "cert_number": "เลขใบรับรอง",
    "condition_note_en": "หมายเหตุสภาพ (อังกฤษ)",
    "sealed_subtype": "ชนิดสินค้าซีล",
    "seo_title": "ชื่อสำหรับเครื่องมือค้นหา",
    "seo_description": "คำอธิบายสำหรับเครื่องมือค้นหา",
    "media_urls": "ลิงก์รูป",
    "game": "เกม",
    "set": "ชุด",
    "number": "เลขการ์ด",
    "language": "ภาษาการ์ด",
    "kind": "ประเภท (ดิบ / เกรด / ซีล)",
    "rank": "แรงก์ (A–D)",
    "grader": "บริษัทเกรด",
    "cert": "เลขใบรับรอง",
    "note": "หมายเหตุ",
    "ref": "เลขอ้างอิงของคุณ",
    "name": "ชื่อการ์ด"
  }
}
